import axios from 'axios'
import { Toast } from 'vant'

// 创建一个 axios 实例
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    headers: {
        'Content-Type': 'application/json'
    },
    timeout: 5000
})

// 请求拦截器
service.interceptors.request.use(
    config => {
        Toast.loading({
            message: "加载中...",
            forbidClick: true,
            duration:0
        });
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

// 响应拦截器
service.interceptors.response.use(
    response => {
        Toast.clear()
        const res = response.data
        if(res.code === 200){
            return res
        }else{
            Toast({
                message: res.message || 'Error'
            })
            return Promise.reject(new Error(res.message || 'Error'))
        }
    },
    error => {
        Toast({
            message: error.response.data.msg || 'Error'
        })
        return Promise.reject(error)
    }
)

export default service